import styled, { css } from 'styled-components';

export const TabsWrapper = styled.div<{ extraRight?: boolean }>`
  display: flex;
  gap: 24px;
  padding: 0;
  padding-right: ${(props) => (props.extraRight ? '115px' : '0px')};
  box-sizing: border-box;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(p) => p.theme.colors.stroke};
  margin-bottom: 24px;
`;

const ActiveTabStyle = css`
  a {
    color: ${(p) => p.theme.colors.brand};

    &:hover {
      color: ${(p) => p.theme.colors.brand};
    }
  }
  border-bottom: 2px solid ${(p) => p.theme.colors.brand};
`;

const DisabledTabStyle = css`
  color: ${(p) => p.theme.colors.muted};
`;

export const Tab = styled.div<{ isActive: boolean; disabled: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
  background-color: transparent;
  border: none;
  margin-bottom: -1px;
  
  overflow: hidden;

  a {
    color: ${(p) => p.theme.colors.text};
    text-decoration: none;
    height: 100%;
    line-height: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      color: #0073f7;
    }
  }

  ${(p) => p.theme.typography.description};
  ${({ isActive }) => isActive && ActiveTabStyle}};
  ${({ disabled }) => disabled && DisabledTabStyle}};
`;
